// ** Core Layout Import
// !Do not remove the Layout import
import Layout from "@layouts/VerticalLayout";

// ** Menu Items Array
import navigation from "@src/navigation/vertical";
import { roleUser } from "../views/apps/ecommerce/utils/utils";
import "../views/apps/ecommerce/assets/styles.css";
import "../views/apps/ecommerce/assets/darkStyle.css";
import {
  Box,
  Briefcase,
  Circle,
  DollarSign,
  File,
  FilePlus,
  FileText,
  Headphones,
  HelpCircle,
  Home,
  Layers,
  MessageSquare,
  Settings,
  Users,
} from "react-feather";

const VerticalLayout = (props) => {
  // const [menuData, setMenuData] = useState([])

  // ** For ServerSide navigation
  // useEffect(() => {
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])

  // client menu
  const icon = [
    <Home />,
    <MessageSquare />,
    <Headphones />,
    <DollarSign />,
    <FileText />,
    <Layers />,
    <File />,
    <Box />,
    <Users />,
    <Briefcase />,
    <FilePlus />,
    <HelpCircle />,
    <DollarSign />,
    <Settings />,
  ];

  let tempArray = [];
  const clientMenu = [
    "company Operation",
    "message",
    "client-ticket",
    "all-projects",
    "client-milestones",
    "invoices",
    "contracts",
    "estimates",
    "client-work-app",
    "client-team",
    "client-help-center",
    "client-service",
    "client-profile",
    "client-setup-wizard",
  ];

  if (roleUser() == "client" || roleUser() == "undefined") {
    for (let i = 0; i < navigation.length; i++) {
      if (navigation[i].children?.length) {
        for (let j = 0; j < navigation[i].children.length; j++) {
          if (navigation[i].children[j]?.children?.length) {
            for (
              let n = 0;
              n < navigation[i].children[j]?.children?.length;
              n++
            ) {
              if (
                clientMenu.includes(navigation[i].children[j].children[n].id)
              ) {
                tempArray.push(navigation[i].children[j].children[n]);
              }
            }
          }
          if (clientMenu.includes(navigation[i].children[j].id)) {
            tempArray.push(navigation[i].children[j]);
          }
        }
      }

      if (clientMenu.includes(navigation[i].id)) {
        tempArray.push(navigation[i]);
      }
    }

    var newIconTempArray = tempArray.map((item, index) => {
      return { ...item, icon: icon[index] || <Circle /> };
    });
    // navigation.splice(0, navigation.length, ...newIconTempArray);
  }

  const excludedIds = [
    "client-milestones",
    "client-work-app",
    "client-team",
    "client-help-center",
    "client-service",
    "client-profile",
    "client-setup-wizard",
  ];

  if (roleUser() != "client" || roleUser() != "undefined") {
    var newNavigation = navigation.filter(
      (item, index) => !excludedIds.includes(item.id)
    );
    // navigation.splice(0, navigation.length, ...newNavigation);
  }

  return (
    <Layout
      menuData={
        roleUser() == "client" || roleUser() == "undefined"
          ? newIconTempArray 
          : newNavigation
      }
      {...props}
    >
      {props.children}
    </Layout>
  );
};

export default VerticalLayout;
